module.exports = __webpack_public_path__ + "static/media/emptydiary.091eb7c1.svg";